import { render } from "./ButtonRequest.vue?vue&type=template&id=00af8d06&scoped=true&ts=true"
import script from "./ButtonRequest.vue?vue&type=script&lang=ts"
export * from "./ButtonRequest.vue?vue&type=script&lang=ts"

import "./ButtonRequest.vue?vue&type=style&index=0&id=00af8d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00af8d06"]])

export default __exports__